import React, { Component } from 'react';
import PT from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getPages, getPage } from 'ducks/brandPortal';

import { BrandPortal } from 'modules';

class BrandPortalPage extends Component {
  componentDidMount() {
    if (this.props.pages.length === 0) this.props.getPages();
    this.getPage(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.page !== nextProps.match.params.page
      || this.props.pages.length !== nextProps.pages.length) {
      this.getPage(nextProps);
    }
  }

  getPage = (props) => {
    const { match: { params }, pages } = props;

    if (pages.length > 0) {
      const currentPage = pages.find(page => page.slug === params.topic).top_pages
        .find(topPage => topPage.slug === params.page);

      this.props.getPage(currentPage.id);
    }
  }

  render() {
    return (
      <BrandPortal pages={this.props.pages} page={this.props.page} />
    );
  }
}

BrandPortalPage.propTypes = {
  getPages: PT.func,
  pages: PT.array,
  match: PT.object,
  page: PT.object,
  getPage: PT.func,
};

export default compose(
  withRouter,
  connect(state => ({
    pages: state.brandPortal.pages,
    page: state.brandPortal.page,
  }), { getPages, getPage }),
)(BrandPortalPage);
